import UrlMatch from '@fczbkk/url-match'
import newHost2Keymap from "./newHost2Keymap";


const pendoWest = '908664d4-a4a6-4a26-4764-eeb5bdcbc55c';
const pendoEast = '52d2999e-74c1-42e4-6d53-4842de1a50df';

const host2keyMap = {}

Object.assign(host2keyMap, newHost2Keymap);

function getKey(targetSdk) {
		const hname = location.hostname;
	let ret = '';
	if(hname in host2keyMap) {
		ret = host2keyMap[hname][targetSdk];
	} else {
		Object.keys(host2keyMap).forEach(function (hostMatchString) {
			if(hostMatchString.indexOf('*') >=0) {
				const mt = new UrlMatch(hostMatchString);
				if(mt.test(hname)) {
					ret = host2keyMap[hostMatchString][targetSdk];
				}
			}
		})
	}
	return ret;
}

export function getSegmentKeyByHost() {
	return getKey('seg');
}

export function getPendoKeyByHost() {
	return getKey('pendo');
}

export function getPendoKeyByEnv(env='qa') {
	if(['release', 'releaseb', 'b'].indexOf(env) >= 0) {
		return pendoEast
	}
	if(['qa', 'qab'].indexOf(env) >= 0) {
		return pendoWest;
	}
	return ''
}
